const day = 1000 * 60 * 60 * 24;
module.exports = {
	init() {
		this.buttons = this.root.querySelectorAll('[data-close]');
		this.root.addEventListener('click', e => {
			if (e.target.dataset.close === '') {
				this.close();
			}
		});
		if (this.shouldShow()) this.show();
		if (!this.isInternetExplorer()) {
			const ieWarningDiv = document.querySelector('.ie-warning');
			if (ieWarningDiv) {
				this.root.remove();
			}
		}
	},
	shouldShow() {
		const now = Date.now();
		const isIE = window.navigator.userAgent.indexOf('Trident/') !== -1;
		const expiration = window.localStorage.getItem('ieWarning');
		const isDeactivated = expiration && expiration > now;
		return isIE && !isDeactivated;
	},
	show() {
		this.root.style.display = 'flex';
	},
	close() {
		this.root.style.display = 'none';
		window.localStorage.setItem('ieWarning', Date.now() + day);
	},
	isInternetExplorer() {
		return /Trident\/|MSIE/.test(window.navigator.userAgent);
	},
};
